/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'

// Components
import {
    Box,
    PopoverTrigger,
    Link,

    // Hooks
    useTheme
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Project Components
// import Link from '@salesforce/retail-react-app/app/components/link'

// Others
import {categoryUrlBuilder} from '../../utills/url'

const ListMenuTrigger = ({item, name, isOpen, onOpen, onClose}) => {
    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu

    const isTouchDevice = () =>
        typeof window !== 'undefined' &&
        window?.matchMedia('(hover: none) and (pointer: coarse)')?.matches

    const restrictL1Redirection = (e) => {
        e.preventDefault()
        if (isTouchDevice()) {
            onOpen()
        }
    }
    return (
        <Box {...baseStyle.listMenuTriggerContainer}>
            <PopoverTrigger>
                <Link
                    as={RouteLink}
                    // to={categoryUrlBuilder(item)}
                    href="javascipt:void(0)"
                    onPointerEnter={!isTouchDevice() ? onOpen : undefined}
                    onClick={restrictL1Redirection}
                    {...baseStyle.listMenuTriggerLink}
                    {...{name: name + ' __'}}
                    {...(isOpen ? baseStyle.listMenuTriggerLinkActive : {})}
                >
                    {name}
                </Link>
            </PopoverTrigger>
        </Box>
    )
}

ListMenuTrigger.propTypes = {
    item: PropTypes.object,
    name: PropTypes.string,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}

export {ListMenuTrigger}
